<template>
  <div class="home page">
    <h1 class="page-title" data-title="Gestion des balises">Gestion des balises</h1>
    <h2 class="section-title">Mes balises placées</h2>
    <ul class="beacon-list beacon-list--placed">
      <router-link
        v-for="(beacon, index) in placedBeacons" :key="index"
        tag="li"
        :to="{ name: 'Beacon-Single', params: { index: beacon.beacon_id } }"
        class="beacon-list__item">
        <span class="beacon-list__name">Balise {{ beacon.beacon_id }}</span>
        <span>Déposée le {{ beacon.start_date }}</span>
      </router-link>
    </ul>
    <h2 class="section-title">Mes anciennes balises placées</h2>
    <ul class="beacon-list">
      <router-link
        tag="li"
        :to="{ name: 'Beacon-Single', params: { index: beacon.beacon_id } }"
        class="beacon-list__item"
        v-for="(beacon, index) in pickedBeacons" :key="index">
        <span class="beacon-list__name">Balise {{ beacon.beacon_id }}</span>
        <span>Déposée le {{ beacon.start_date }}</span>
        <span>Retirée le {{ beacon.end_date }}</span>
      </router-link>
    </ul>
    <div class="floating-btn">
      <router-link title="Ajouter une balise" to="/place-beacon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 4.8 6.4 12 9.6 19.2 9.6 7.2 0 14.4-3.2 19.2-9.6C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 446.09c-14.41-20.56-27.51-39.13-39.41-56C58.35 256.48 48 240.2 48 192c0-79.4 64.6-144 144-144s144 64.6 144 144c0 48.2-10.35 64.48-104.59 198.09-11.9 16.87-25 35.44-39.41 56zM272 168h-56v-56c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v56h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"/></svg>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['beacons']),
    placedBeacons () {
      return this.beacons.filter(beacon => beacon.status === 'placed')
    },
    pickedBeacons () {
      return this.beacons.filter(beacon => beacon.status === 'picked')
    }
  },
  created () {
    this.$store.dispatch('getBeacons')
  }
}
</script>
